import { Grid } from '@material-ui/core';
import { omit } from 'lodash';
import { useCallback, useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectConditionalSteps,
  selectSubMode,
} from '../../../../../features/declaracao-importacao/declaracaoImportacaoSelectors';

import {
  changeToSubBackgroundConsultMode,
  changeToSubConsultMode,
  changeToSubCreateMode,
  changeToSubUpdateMode,
  loading,
  resetStatus,
  resetSubBackgroundMode,
  resetSubMode,
} from '../../../../../features/declaracao-importacao/declaracaoImportacaoSlice';
import QCXFinalFormWizard from '../../../../../shared-components/final-form-wizard/QCXFinalFormWizard';
import { isNoneSubMode, isSubConsultMode, isSubCreateMode, isSubUpdateMode, isConsultMode } from '../../../../../utils/store/store-utils';

import TarifarioAereoDataForm from './TarifarioAereoDataForm';
import TarifarioCustosAdicionaisDataForm from './TarifarioCustosAdicionaisDataForm';
import TarifaUnidadesCompartilhadasDataForm from './TarifaUnidadesCompartilhadasDataForm';

export default function TarifarioAereoWizardFinalForm({
  handleSubmit,
  handleAlternativeSave,
  handleChangeToPreparingAction,
  model,
  handleChangeModel,
  handleChangeToCreate,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  handleChangeToBackgroundCreate,
  handleResetBackgroundMode,
  isCreate,
  isConsult,
  isUpdate,
  isBackgroundCreate,
  isPreparingAction,
  authInfo = {},
  requiredRoles = [],
  ...restProps
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const subMode = useSelector(selectSubMode);

  const isSubNone = useMemo(() => isNoneSubMode(subMode), [subMode]);
  const isSubCreate = useMemo(() => isSubCreateMode(subMode), [subMode]);
  const isSubConsult = useMemo(() => isSubConsultMode(subMode), [subMode]);
  const isSubUpdate = useMemo(() => isSubUpdateMode(subMode), [subMode]);

  const handleLoadingStatus = useCallback(() => dispatch(loading()), []);
  const handleResetStatus = useCallback(() => dispatch(resetStatus()), []);

  const handleChangeToSubCreate = useCallback(() => {
    dispatch(changeToSubCreateMode());
  }, []);

  const handleChangeToSubConsult = useCallback(() => {
    dispatch(resetSubBackgroundMode());
    dispatch(changeToSubConsultMode());
  }, []);

  const handleChangeToSubUpdate = useCallback(() => {
    dispatch(changeToSubBackgroundConsultMode());
    dispatch(changeToSubUpdateMode());
  }, []);

  const handleChangeToSubNone = () => {
    dispatch(resetSubMode());
  };


  const wizardSteps = useMemo(() => {
    const stepsLabels = [
      t('com.muralis.qcx.basicas'),
      "Custos Adicionais",
      "Unidades Compartilhadas",
    ];

    return stepsLabels;
  }, []);


  const handleFormSubmit = (values, step, next) => {
    const transformedValues = {...values};
    handleSubmit(transformedValues, step, next);
  };

  const checkIfIsAlternativeSaveByStep = (currentStep) => (false);

  return (
      <QCXFinalFormWizard
        steps={wizardSteps}
        initialValues={model}
        handleChangeValues={handleChangeModel}
        isCreate={isCreate}
        isConsult={isConsult}
        isUpdate={isUpdate}
        isBackgroundCreate={isBackgroundCreate}
        isSubNone={isSubNone}
        isSubCreate={isSubCreate}
        isSubConsult={isSubConsult}
        isSubUpdate={isSubUpdate}
        handleSubmit={handleSubmit}
        checkIfIsAlternativeSaveByStep={checkIfIsAlternativeSaveByStep}
        handleAlternativeSave={handleAlternativeSave}
        handleChangeToCreate={handleChangeToCreate}
        handleChangeToConsult={handleChangeToConsult}
        handleChangeToUpdate={handleChangeToUpdate}
        handleCancelUpdate={handleCancelUpdate}
        handleChangeToBackgroundCreate={handleChangeToBackgroundCreate}
        handleResetBackgroundMode={handleResetBackgroundMode}
        {...restProps}
      >

        {(formProps) => (
          <TarifarioAereoDataForm
            key="dados-tarifario-aereo"
            isUpdate={isUpdate}
            isConsult={isConsult}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            {...formProps}
          />
        )}

        {(formProps) => (
          <TarifarioCustosAdicionaisDataForm
            key="dados-custos-adicionais"
            isUpdate={isUpdate}
            isConsult={isConsult}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            {...formProps}
          />
        )}

        {(formProps) => (
          <TarifaUnidadesCompartilhadasDataForm
            key="dados-unidades-compartilhadas"
            isUpdate={isUpdate}
            isConsult={isConsult}
            authInfo={authInfo}
            requiredRoles={requiredRoles}
            model={model}
            {...formProps}
          />
        )}
      </QCXFinalFormWizard>
  );
}
